/*
 * @Author: ryyyyy
 * @Date: 2022-02-16 17:41:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-24 17:03:24
 * @Description: Do not edit
 * @FilePath: /create-data-app/src/utils/request.js
 */
import axios from 'axios';
import qs from 'qs'
import { message } from 'antd'

let isLogin = false
const baseConfig = {
  headers: {
    // 'Content-Type': 'application/json',
  },
  timeout: 3600000, // 1小时
  // baseURL: process.env.MODE === 'development' ? 'http://10.2.45.37:8080/202308/wenchuang/' : 'https://eventsys.games.wanmei.com/api/',
  baseURL: process.env.MODE === 'development' ? 'http://dev-event.sys.wanmei.net/api/202308/wenchuang/' : '/api/202308/wenchuang/',
  // baseURL: '/api/202308/wenchuang/',
  // baseURL: 'https://eventsys.games.wanmei.com/api/202208/wenchuang/'
};

if (process.env.MODE === 'development') {
  baseConfig.headers['X-SSO-UID'] = 'qichong';
}

const onError = (errorMsg) => {
  return {
    success: false,
    message: errorMsg,
    data: null,
  };
};

const onSuccess = (response) => {
  if (response.data && response.status === 200) {
    if (response?.data?.code !== 0 && isLogin && response?.data?.type == 'noLogin') {
      message.error('请重新登录')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userId')

      //跳转到登录页面
      window.location.href = './#/login'
    }
    return {
      ...response.data,
    };
  }

  const responseURL = response.request.responseURL;
  if (process.env.MODE === 'development') {
    console.group(responseURL);
    console.error(responseURL);
    console.error(response.data);
    console.groupEnd(responseURL);
  }
  return {
    success: false,
    data: response.data?.data,
  };
};

const instance = axios.create(baseConfig);

instance.interceptors.response.use(
  (response) => onSuccess(response),
  (error) => onError(error.toString())
);

// 数组转成,链接
function formatParams(params = {}) {
  const r = {};
  Object.keys(params).forEach((key) => {
    if (Array.isArray(params[key])) {
      r[key] = params[key].join(',');
    } else {
      r[key] = params[key];
    }
  });
  return r;
}


const getHeaders = () => {
  let token = window.localStorage.getItem('token')
  let userId = window.localStorage.getItem('userId')
  if (token && userId) {
    return {
      token, 'user-id': userId, 'judge-id': userId
    }
  }
  return {}
}

const request = {
  get: (url, params = {}, extra = {}) => {
    isLogin = !!params.isLogin
    return instance.get(url, {
      params: formatParams(params),
    }, { ...extra, headers: getHeaders() });
  },
  post: (url, data = {}, extra = {}) => {
    isLogin = !!data.isLogin
    return instance.post(url, qs.stringify(data), { ...extra, headers: getHeaders() });
  },
};

// 普通接口
export default request;

const downloadInstanse = axios.create(baseConfig);

export const downloadRequest = {
  post: (url, data) => {
    return downloadInstanse.request({
      method: 'post',
      url: url,
      data: data,
      responseType: 'blob',
    });
  },
  get: (url, params = {}) => {
    return downloadInstanse.request({
      method: 'get',
      url: url,
      params: formatParams(params),
      responseType: 'blob',
    });
  },
};
